const Style = ({ attributes, clientId }) => {
	const { verticalAlign, textAlign, bgOverlay, minHeight, padding } = attributes;

	return <style dangerouslySetInnerHTML={{
		__html: `
		#vbbVideoBG-${clientId}{
			min-height: ${minHeight};
		}
		#vbbVideoBG-${clientId} .vbbVideoContent{
			justify-content: ${verticalAlign};
			text-align: ${textAlign};
			min-height: ${minHeight};
			padding: ${padding?.styles || '20px 30px'};
		}
		#vbbVideoBG-${clientId} .vbbVideoOverlay{
			${bgOverlay?.styles || ''}
		}
		`.replace(/\s+/g, ' ')
	}} />
}
export default Style;